import { render } from "./TwilioChannel.vue?vue&type=template&id=f7890b9a"
import script from "./TwilioChannel.vue?vue&type=script&lang=js"
export * from "./TwilioChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__